import { useState } from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { Button } from '@/components/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

type Props = {
  memo: string;
  maxLength?: number;
};

export default function MemoDisplay({ memo, maxLength = 10 }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const truncatedMemo = memo.length > maxLength ? `${memo.slice(0, maxLength)}...` : memo;

  return (
    <div className="flex items-center gap-2 border-l border-solid border-gray-300 pl-4">
      <p className="text-xs font-bold">社内メモ</p>
      {memo.length > maxLength ? (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
          <span className="text-xs">{truncatedMemo}</span>
          <PopoverTrigger asChild>
            <Button size="xs" color="secondary" iconOnly>
              <MdOutlineKeyboardArrowDown
                className={`size-icon-3xs transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
              />
            </Button>
          </PopoverTrigger>
          <PopoverContent
            align="start"
            className="max-w-screen-sm rounded-sm bg-white px-sm py-xs break-words"
          >
            <div className="text-xs whitespace-pre-wrap">{memo}</div>
          </PopoverContent>
        </Popover>
      ) : (
        <p className="text-xs">{memo}</p>
      )}
    </div>
  );
}
